module.exports = __webpack_public_path__ + "img/selected7-min.4e7e13df.png";